import { lazy, Suspense } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const SettingOrganizationPage = lazy(() => import('src/pages/setting/organization'));

// ----------------------------------------------------------------------

export const settingRoutes: RouteObject[] = [
  {
    path: 'setting',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <SettingOrganizationPage />, index: true },
    ],
  },
];
